// extracted by mini-css-extract-plugin
export default {"root":"BasicInfoForm_root__-EHN0","after":"BasicInfoForm_after__3yBw0"};